<section class="min-vh-100 overflow-hidden position-relative bcx-diagonal-hero">
  <!-- =========================
       BLACK BASE LAYER
  ========================== -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-black"></div>

  <!-- =========================
       WHITE DIAGONAL LAYER (full-height left panel, diagonal right edge)
  ========================== -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bcx-diagonal-white"></div>

  <!-- =========================
       CONTENT — confined to left (white) / right (black) columns
       so text never has to straddle the diagonal seam
  ========================== -->
  <div class="container-fluid px-3 px-md-4 px-lg-5 position-relative z-3 min-vh-100 d-flex align-items-center bcx-diagonal-copy">
    <div class="row align-items-center w-100 gy-4">

      <!-- LEFT / WHITE SIDE -->
      <div class="col-12 col-lg-3">
        <h1 class="fw-bold display-5 mb-0 bcx-diagonal-line-dark">
          {{ hero_data.headline_dark }}
        </h1>
      </div>

      <!-- RIGHT / BLACK SIDE -->
      <div class="col-12 col-lg-6 offset-lg-3">

        <p class="text-uppercase text-danger fw-bold text-xs mb-2" style="letter-spacing: 0.06em;">
          {{ hero_data.eyebrow }}
        </p>

        <h1 class="fw-bold display-3 mb-4 bcx-diagonal-line-light">
          {{ hero_data.headline_light }}
        </h1>

        <p class="bcx-diagonal-sub mb-4">
          {{ hero_data.sub_headline }}
        </p>

        <div class="d-flex gap-3 align-items-center">
          <router-link
            to="/login"
            class="btn btn-primary bcx-cta-btn text-decoration-none d-inline-flex align-items-center gap-2"
          >
            {{ hero_data.btn_text }}
            <i class="bi bi-arrow-right"></i>
          </router-link>
        </div>

      </div>
    </div>
  </div>
</section>
